
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'
import { ReactSVG } from 'react-svg'

import { formatAmount, formatAmountWithUnitMultiplier } from '@entities/Product/helpers'

import { Maybe, Product, UserOrderProductPosition } from '@shared/generated'
import ImageWithBg from '@shared/ui/image-with-bg'
import { formatPrice } from '@shared/uttils'
import { ORDER_POSITION_STATUS } from '@shared/uttils/orderStatus'

import styles from './styles.module.scss'

interface IOrderItemProps {
  data: Maybe<UserOrderProductPosition>;
  onNavToProduct: (productSlug?: string) => void;
}

export default function OrderOnlineItem ({ data, onNavToProduct }: IOrderItemProps) {
  const { t: t } = useTranslation('order')
  const { t: tc } = useTranslation('common')
  if (!data) return null

  const { changedBy, isChangeTo } = data

  const renderItem = (item: UserOrderProductPosition, className?: string) => {
    const statusInfo = item.status
      ? ORDER_POSITION_STATUS[item.status as keyof typeof ORDER_POSITION_STATUS]
      : null

    const hasProduct = !!item.product

    const handleClick = hasProduct ? () => {
      onNavToProduct(item.product?.slug as string)
    } : undefined

    return (
      <div key={item.id} className={classNames(styles.orderItem, className)}>
        <ImageWithBg
          className={classNames(
            styles['orderItem__img'],
            hasProduct && styles['orderItem__img--clickable']
          )}
          src={item.product?.preview?.url ?? '/icons/flower-grey.svg'}
          onClick={handleClick}
        />
        <p
          className={classNames(
            styles['orderItem__text'],
            hasProduct && styles['orderItem__text--clickable']
          )}
          onClick={handleClick}
        >
          {item.name}
        </p>
        <span className={styles['orderItem__description']}>
          { formatAmount({
            product: item.product as Product,
            amount: (item.assembled_count && item.assembled_count > 0 ? item.assembled_count : item.count) as number,
            t: tc,
            showOne: true,
          }) }
        </span>
        {statusInfo && (
          <span
            data-color={statusInfo.color}
            className={styles['orderItem__status']}
          >
            {t(statusInfo.title)}
          </span>
        )}
        <div className={styles['orderItem__price']}>
          <span className={styles['orderItem__price-current']}>
            {formatPrice(item.total ?? 0)}
          </span>
          <span className={styles['orderItem__price-perUnit']}>
            {formatPrice(item.price ?? 0)} / {formatAmountWithUnitMultiplier({
              product: item.product as Product,
              unit_multiplier: item.unit_multiplier as number,
              t: tc
            })}
          </span>
        </div>
      </div>
    )
  }

  if (changedBy) {
    return (
      <div className={styles.replacement}>
        <div className={styles.replacement__title}>
          <ReactSVG
            className={styles.replacement__icon}
            src="/icons/arrows-left-right.svg"
            width={16}
            height={16}
            wrapper="span"
          />
          <p>{tc('replacement')}</p>
        </div>

        {renderItem(data, styles.replacement__old)}
        {renderItem(changedBy, styles.replacement__new)}
      </div>
    )
  }

  if (isChangeTo) {
    return null
    // (
    //   <div className={styles.replacement}>
    //     <div className={styles.replacement__title}>
    //       <ReactSVG
    //         className={styles.replacement__icon}
    //         src="/icons/arrows-left-right.svg"
    //         width={16}
    //         height={16}
    //         wrapper="span"
    //       />
    //       <p>{tc('replacement')}</p>
    //     </div>
    //     {renderItem(isChangeTo, styles.replacement__old)}
    //     {renderItem(data, styles.replacement__new)}
    //   </div>
    // )
  }

  return renderItem(data)
}
